import { useStorage } from "@vueuse/core";
import { type Duration, intervalToDuration, isValid } from "date-fns";

const userLocale = useStorage("locale", "en-US");

interface DateFormatArguments {
	value: Date;
	locale?: string;
	options?: Intl.DateTimeFormatOptions;
}

export const formatDate = ({
	value,
	locale,
	options = {
		formatMatcher: "best fit",
		dateStyle: "full",
		timeStyle: undefined,
		dayPeriod: undefined,
		fractionalSecondDigits: undefined,
	},
}: DateFormatArguments) => {
	if (!isValid(value)) return "—";

	return new Intl.DateTimeFormat(locale ?? userLocale.value, options).format(value);
};

export const minutesToDuration = (minutes: number): Duration => {
	return intervalToDuration({ start: 0, end: minutes * 60 * 1000 });
};
